module.exports = __webpack_public_path__ + "static/media/skeleton_archer_circle.2592ebfa.png";